
define('text!modules/campaigns/campaigns_template.html',[],function () { return '<div class="js-weekly-offers-header"></div>\r\n<div class="js-weekly-offers-list"></div>\r\n<div class="js-weekly-offers-pagination"></div>\r\n<div class="js-preview-iframe"></div>\r\n<div class="js-campaign-loader is-hidden"></div>\r\n';});

